<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            <i class="icon-note"></i> {{ titulo }}
            <router-link
              v-show="!isCk"
              class="pull-right btn btn-sm btn-success text-white"
              to="/comprobantes-diario/crear"
            >
              <i class="fa fa-plus" /> Nuevo
            </router-link>
            <router-link
              v-show="isCk"
              class="pull-right btn btn-sm btn-success text-white"
              to="/cheques-transferencias/crear"
            >
              <i class="fa fa-plus" /> Nuevo
            </router-link>
          </div>
          <b-row>
            <b-form-group label="" style="margin-top: 2.1em">
              <b-form-radio-group
                id="btn-radios-2"
                v-model="estado"
                :options="options"
                buttons
                button-variant="outline-primary"
                size="sm"
                name="radio-btn-outline"
                @input="getRegistros"
              ></b-form-radio-group>
            </b-form-group>

            <b-col cols="12" col sm="6" md="3" lg="2" class="separacionderecha">
              <label for="desde"> Desde:&nbsp; </label><br />
              <date-picker
                id="desde"
                :lang="lang"
                v-model="desde"
                format="YYYY-MM-DD"
                type="date"
              >
              </date-picker>
            </b-col>
            <b-col
              cols="12"
              col
              sm="6"
              md="3"
              lg="2"
              class="separacionizquierda"
            >
              <label for="hasta"> Hasta:&nbsp; </label><br />
              <date-picker
                id="hasta"
                :lang="lang"
                v-model="hasta"
                format="YYYY-MM-DD"
                type="date"
              >
              </date-picker>
            </b-col>
            <b-col
              cols="12"
              col
              sm="6"
              md="3"
              lg="2"
              class="separacionizquierda"
              ><br />
              <button
                style="margin-top: 0.4em"
                class="btn btn-success text-white"
                @click="comprobarRango"
              >
                <i class="fa fa-search"></i> Cargar Registros
              </button>
            </b-col>
          </b-row>
        <b-row class="mt-2" v-show="!isCk">
            <b-col cols="6" v-show="estado == 0 && getAutorizaComprobantes == 1">
              <b-button
                pill
                :variant="variente"
                :disabled="botondisable"
                @click="autorizarSelecc()"
              >
                Aprobar <i class="icon icon-check"></i>
              </b-button>
            </b-col>
          </b-row><br/>
          <b-row>
            <b-col cols="12" class="table-responsive" style="min-height: 200px;">
              <b-table
                hover
                small
                show-empty
                empty-text="No hay registros para mostrar"
                responsive="sm"
                :items="items"
                :fields="fields"
                :per-page="pageSize"
                :busy="isLoading"
              >
                <template v-slot:table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>&nbsp; &nbsp;Cargando...</strong>
                  </div>
                </template>
                <template slot="top-row">
                  <td> </td>
                  <td style="width:1.1em;">
                    <date-picker
                      :lang="lang"
                      v-model="fechaFiltro"
                      format="YYYY-MM-DD"
                      type="date"
                      style="max-width:100%; margin:0 auto;"
                    >
                    </date-picker>
                  </td>
                  <td style="width:10em;">
                    <input
                      type="text"
                      v-model="codigo"
                      class="form-control"
                      v-on:keyup.enter="getRegistros()"
                      style="max-width:90%; margin:0 auto;"
                    />
                  </td>
                  <td v-show="isCk">
                    <input
                      type="text"
                      v-model="paguese_a"
                      class="form-control"
                      v-on:keyup.enter="getRegistros()"
                    />
                  </td>
                  <td style="width:19em;">
                    <input
                      type="text"
                      v-model="monto"
                      class="form-control"
                      v-on:keyup.enter="getRegistros()"
                      style="max-width:90%;"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      v-model="concepto"
                      class="form-control"
                      v-on:keyup.enter="getRegistros()"
                    />
                  </td>
                  <td style="width:6%;">
                    <b-form-select
                      v-model="anulado"
                      :options="sino"
                      @input="getRegistros()"
                    ></b-form-select>
                  </td>
                  <td></td>
                </template>
               <template v-slot:cell(check)="row">
                  <b-form-group>
                    <b-form-checkbox
                      v-show="row.item.anulado == '0' && row.item.estado == '0'"
                      v-model="row.item.check"
                      value="true"
                      unchecked-value="false"
                      :state="true"
                      @input="habilitarAprobar"
                    >
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(paguese_a)="row">
                  <div v-show="isCk"> {{ row.item.paguese_a }} </div>
                </template>
                <template v-slot:cell(fecha)="row">
                  {{ formatoFecha(row.item.fecha) }}
                </template>
                <template v-slot:cell(total_debe)="row">
                  {{
                    row.item.total_debe
                      | currency("", 2, { thousandsSeparator: "," })
                  }}
                </template>
                <template v-slot:cell(monto_ck)="row">
                  {{
                    row.item.monto_ck
                      | currency("", 2, { thousandsSeparator: "," })
                  }}
                </template>
                <template v-slot:cell(valoranulado)="row">
                  <span v-show="row.item.anulado == '1'">Si</span>
                  <span v-show="row.item.anulado == '0'">No</span>
                </template>
                <template v-slot:row-details="row">
                  <b-card>
                    <b-row class="mb-2">
                      <b-col sm="7" offset-sm="3" class="table-responsive">
                        <span class="pull-right"
                          >&nbsp; &nbsp; Tipo Cambio:
                          <strong>{{
                            row.item.tasa_cambio
                          }}</strong></span
                        >
                        <p v-show="row.item.enlace_referencia">
                        Ref: <a :href="row.item.enlace_referencia" target="_blank">{{row.item.enlace_referencia}}</a>
                        </p>
                        <p v-show="row.item.transferencia_id">
                          Transferencia: <strong>{{row.item.transferencia_id}}</strong>
                        </p>
                        <table class="table table-condensed table-hover" style="font-weight: bold">
                          <tr>
                            <td class="text-info">Cuenta:</td>
                            <td class="text-info">Descripcion Cuenta:</td>
                            <td class="text-info">Debito:</td>
                            <td class="text-info">Credito:</td>
                          </tr>
                          <tbody>
                            <tr
                              v-for="(detalle, index) in row.item.vdetalles"
                              :key="`${index}`"
                            >
                              <td>{{ detalle.cuenta }}</td>
                              <td>{{ detalle.cta_nombre }}</td>
                              <td class="text-right">{{ detalle.debito | currency("", 2, { thousandsSeparator: "," }) }}</td>
                              <td class="text-right">{{ detalle.credito | currency("", 2, { thousandsSeparator: "," })}}</td>
                            </tr>
                          <tr>
                            <td class="negrita text-right" colspan="2">Totales:</td>
                            <td class="negrita text-right"> {{
                                row.item.total_debe
                                  | currency("", 2, { thousandsSeparator: "," })
                              }}</td>
                            <td class="negrita text-right"> {{
                                row.item.total_haber
                                  | currency("", 2, { thousandsSeparator: "," })
                              }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </b-col>
                      <b-col>
                        <b-button
                          class="pull-left"
                          size="sm"
                          @click="row.toggleDetails"
                          >Ocultar Detalle <i class="fa fa-eye-slash"></i>
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-card>
                </template>
                <template v-slot:cell(actions)="row">
                  <b-dropdown
                    size="sm"
                    text="Acciones"
                    variant="outline-primary"
                  >
                    <b-link
                      v-show="row.item.anulado == '0' && row.item.estado == '0' && row.item.total_debe == row.item.total_haber"
                      @click="autorizar(row.item.id, row.item.codigo)"
                      title="Aprobar"
                      class="dropdown-item"
                    ><i class="fa fa-check"> </i>Aprobar
                    </b-link>

                    <b-link
                      v-show="row.item.anulado == '0' && row.item.estado == '1' && !isCk"
                      :to="{
                        name: 'pdf-comprobante',
                        params: {id:row.item.id, name: row.item.codigo }
                      }"
                      title="Imprimir"
                      class="dropdown-item"
                      ><i class="fa fa-print"> </i>Imprimir
                    </b-link>
                    <b-link
                      v-show="row.item.anulado == '0' && row.item.estado == '1' && isCk"
                      :to="{
                        name: 'pdf-ckeque-transferencia',
                        params: {id:row.item.id, name: row.item.codigo }
                      }"
                      title="Imprimir"
                      class="dropdown-item"
                    ><i class="fa fa-print"> </i>Imprimir
                    </b-link>
                    <b-dropdown-item-button
                      v-show="row.item.anulado == '0' && row.item.estado=='0'"
                      :title="texto_boton_editar"
                      @click="editar(row.item.id)"
                      ><i class="fa fa-pencil"> </i>
                      {{ texto_boton_editar }}
                    </b-dropdown-item-button>
                    <b-dropdown-item-button
                      title="Ver Detalle"
                      @click="row.toggleDetails"
                      ><i class="fa fa-eye"> </i>
                      Ver Detalle
                    </b-dropdown-item-button>
                    <b-dropdown-item-button
                      title="Anular"
                      v-show="row.item.anulado == '0' && row.item.asentado =='0'"
                      @click="anular(row.item)"
                      ><i class="fa fa-times"></i>
                      Anular
                    </b-dropdown-item-button>
                    <b-dropdown-item-button
                      title="Activar"
                      v-show="row.item.anulado == '1' && row.item.asentado =='0'"
                      @click="activar(row.item)"
                      ><i class="fa fa-undo"></i>
                      Activar
                    </b-dropdown-item-button>
                  </b-dropdown>
                </template>
              </b-table>
            </b-col>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="pageSize"
              class="mt-4"
              @input="getRegistros"
            ></b-pagination>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import toastr from "toastr";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";
import Vue2Filters from "vue2-filters";
//import { addCommas } from "../../shared/utils";

export default {
  name: "Diario-grid",
  mixins: [Vue2Filters.mixin],
  components: { DatePicker },
  data: () => {
    return {
      url_editar:'/comprobantes-diario/actualizar/',
      titulo : 'Comprobantes de Diario',
      tipo_comprobante:1,
      isCk : false,
      texto_boton_editar:'Editar',
      texto_boton_aurotizados: 'Autorizados',
      variente: "",
      botondisable: true,
      options: [
        { html: ` Pendientes <i class='icon-clock'></i>`, value: 0 },
        { html: ` Aprobados <i class="fa fa-check"></i>`, value: 1 }
      ],
      fechaFiltro: undefined,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1
        }
      },
      isLoading: true,
      desde: "",
      hasta: "",
      anulado: 0,
      codigo: undefined,
      paguese_a: undefined,
      concepto: undefined,
      monto: undefined,
      fecha: undefined,
      items: [],
      currentPage: 1,
      totalRows: 0,
      fields: [
        { label: "", key: "check", sortable: false },
        { key: "fecha", sortable: true, class: "text-center" },
        {
          key: "codigo",
          sortable: true,
          class: "text-center"
        },
        {
          label: "Monto C$",
          key: "total_debe",
          sortable: true,
          class: "text-center"
        },
        { key: "concepto", sortable: true },
        {
          key: "valoranulado",
          sortable: true,
          class: "text-center",
          label: "Anulado"
        },
        {
          label: "",
          key: "actions",
          sortable: false
        }
      ],
      pageSize: 10,
      sino: [
        { value: 1, text: "Si" },
        { value: 0, text: "No" }
      ],
      //Para pdf
      modelPDF: "",
      body: [],
      elaborado: "",
      autorizado: "",
      estado: 0,

    };
  },
  created() {
    this.getRegistros();
  },
  methods: {
    editar(id) {
      this.$router.push(this.url_editar + id);
    },
    habilitarAprobar() {
      this.botondisable = true;
      this.variente = "";
      this.items.forEach(i => {
        if (i.check === "true") {
          this.botondisable = false;
          this.variente = "success";
          return;
        }
      });
    },
    formatoFecha(date) {
      // eslint-disable-next-line no-undef
      return moment(date).format("DD/MM/YYYY");
    },
    async getRegistros() {
      this.isCk = false;

      if(this.$route.name == "cheques") {
        this.titulo = 'Cheques / Transferencias';
        this.isCk = true;
        this.tipo_comprobante =  2;
        this.texto_boton_aurotizados= 'Elaborados';
        this.options[1].html= ` Elaborados <i class="fa fa-check"></i>`;
        this.url_editar='/cheques-transferencias/elaborar/';
        this.fields = [
          { label: "", key: "check", sortable: false },
          { key: "fecha", sortable: true, class: "text-center" },
          {
            key: "codigo",
            sortable: true,
            class: "text-center"
          },
          {
            label: "Pagase a",
            key: "paguese_a",
            sortable: true,
          },
          {
            label: "Monto C$",
            key: "monto_ck",
            sortable: true,
            class: "text-center"
          },
          { key: "concepto", sortable: true },
          {
            key: "valoranulado",
            sortable: true,
            class: "text-center",
            label: "Anulado"
          },
          {
            label: "",
            key: "actions",
            sortable: false
          }
        ];
      }

      this.items = [];
      this.isLoading = true;
      try {// eslint-disable-next-line no-undef
        let desde = this.desde ? moment(this.desde).format("YYYY-MM-DD") : undefined;
        // eslint-disable-next-line no-undef
       let hasta = this.hasta ? moment(this.hasta).format("YYYY-MM-DD") : undefined;
        // eslint-disable-next-line no-undef
       let {data} = await axios.post("/api/comprobantes/index", {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          empresa_id: this.empresaId,
          tipo_comprobante: this.tipo_comprobante,
          desde,
          hasta,
          codigo: this.codigo,
          fecha: this.fecha,
          monto: this.monto,
          concepto: this.concepto,
          anulado: this.anulado,
          estado: this.estado,
         paguese_a : this.paguese_a
        });
        if(data.data){
          let datos = data.data;
          this.items = datos;
        }
        this.totalRows = data.total;
        this.isLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async autorizar(id, cod) {

      let ids = [];
      ids.push(id);
     const {dismiss} = await this.$swal({
        title: "Desea Aprobar?",
        html: `Esta segur@ que desea Aprobar el Comprobante Seleccionado? <strong>(${cod})</strong>, la accion contabilizará los registros y luego no podra editar`,
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Aprobarlo",
        cancelButtonText: "Cancelar"
      });
      if (!dismiss) {
            // eslint-disable-next-line no-undef
            const {data} = await axios.post("/api/comprobantes/autorizar", { ids });
            this.getRegistros();
            this.botondisable = true;
            this.variente = "";
            if (data.status == "fail") return toastr["error"](data.errors);
             return toastr["success"]("Autorizado con exito");
          }
    },
    anular(reg) {
      this.$swal({
        title: "Desea Anular?",
        text: "Esta segur@ que desea Anular el Comprobante Seleccionado?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Anular",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          // eslint-disable-next-line no-undef
          axios.post("/api/comprobantes/anular-activar", { id: reg.id, valor: 1 })
            .then(res => {
              let resp = res.data;
              if (resp.status == "ok") this.isLoading = true;
              this.items = [];
              this.getRegistros();
              this.$swal({
                toast: true,
                position: "top-end",
                html:
                  '<span class="text-success"> Registro Anulado Correctamente</span>',
                type: "success",
                showConfirmButton: false,
                timer: 2000
              });
            });
        }
      });
    },
    activar(reg) {
      this.$swal({
        title: "Desea Activar registro anulado?",
        text: "Esta segur@ que desea Activar Comprobante Seleccionado?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Activar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          // eslint-disable-next-line no-undef
          axios.post("/api/comprobantes/anular-activar", { id: reg.id, valor: 0 })
            .then(res => {
              let resp = res.data;
              if (resp.status == "ok") this.isLoading = true;
              this.items = [];
              this.getRegistros();
              this.$swal({
                toast: true,
                position: "top-end",
                html:
                  '<span class="text-success"> Registro Activado Correctamente</span>',
                type: "success",
                showConfirmButton: false,
                timer: 2000
              });
            });
        }
      });
    },
    cambiarFormatoFecha(date) {
      if (date) {
        // eslint-disable-next-line no-undef
        this.fecha = moment(date).format("YYYY-MM-DD");
      } else this.fecha = undefined;
      this.getRegistros();
    },
    comprobarRango() {
      if (this.desde == undefined || this.desde == "")
        return toastr["warning"]("Favor ingresar una fecha valida en Desde");
      if (this.hasta == undefined || this.hasta == "")
        return toastr["warning"]("Favor ingresar una fecha valida en Hasta");
      this.getRegistros();
    },
    async autorizarSelecc (){
      let vm = this;
      let ids = [];

      const {dismiss} = await vm.$swal({
        title: "Desea Aprobar?",
        html: `Esta segur@ que desea Aprobar los Comprobantes Seleccionados?, la acción contabilizará los registros y luego no podrá editarlos`,
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Aprobarlos",
        cancelButtonText: "Cancelar"
      });
      if (!dismiss) {

        this.items.forEach(i => {
          if (i.check === "true" && i.total_haber == i.total_debe) ids.push(i.id);
        });

        // eslint-disable-next-line no-undef
        let {data} = await axios.post("/api/comprobantes/autorizar", { ids });
        this.getRegistros();
        this.botondisable = true;
        this.variente = "";
        if (data.status == "fail") return toastr["error"](data.errors);
        return toastr["success"]("Autorizado(s) con exito");
      }
    },
  },
   computed: {
    ...mapGetters("authentication", ["empresaId", "getAutorizaComprobantes"]),

  },
  watch: {
    fechaFiltro: _.debounce(function(date) {
      this.cambiarFormatoFecha(date);
    }, 30)
  }
};
</script>
<style scoped>
@media (min-width: 770px) {
  .separacionizquierda {
    width: max-content;
    margin-left: 6em !important;
  }
}

@media (min-width: 785px) {
  .separacionizquierda {
    margin-left: 3em !important;
  }
}
</style>
